export default ({ request }) => ({
  mrpOutsourcingOrderListApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/order/list',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingOrderDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/order/detail',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingOrderSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/order/save',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingOrderDelApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/order/del',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingOrderSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/order/submit',
      method: 'post',
      data,
    })
  },
})
